import { useCallback, useMemo } from 'react';

import type { DayNumber } from '@app/components/Calendars/components/DayNumber/types';
import { daysShort } from '@app/pages/TasksList/constants/dates';
import { useTaskListContext } from '@app/providers/TaskListProvider';

export const useMonthlyCalendar = () => {
  const {
    activeTab,
    toPrevDate,
    toNextDate,
    isCalendarsTabsLoading,
    createTaskForRange,
    openPreviewTaskModal,
  } = useTaskListContext();

  const toPrevMonth = toPrevDate;
  const toNextMonth = toNextDate;
  const getDayNumbers = useCallback(() => {
    if (activeTab !== 'month') {
      return [];
    }

    const dayNumbers: Array<DayNumber> = Array.from({ length: 7 }, (_, i) => ({
      title: daysShort[(i + 1) as keyof typeof daysShort],
      size: 'medium',
      black: true,
    }));

    return dayNumbers;
  }, [activeTab]);

  const dayNumbers: Array<DayNumber> = useMemo(getDayNumbers, [getDayNumbers]);
  return {
    toPrevMonth,
    toNextMonth,
    dayNumbers,
    createTaskForRange,
    openPreviewTaskModal,
    isLoading: isCalendarsTabsLoading,
  };
};
